import * as React from "react";
import * as __intl__ from "@frameio/i18n";
import { type CollectionInfoFragment } from "@frameio/graphql-client/generated";
export type Text = {
    collectionCopyName: (name: CollectionInfoFragment["name"]) => string | React.ReactNode;
    duplicating: string;
    success: string;
    error: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Default name for duplicated collections */
            collectionCopyName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: CollectionInfoFragment["name"]) => __intl__.intl().formatMessage({ id: "useDuplicateCollection.collectionCopyName?c=zvpfgw3qzfn3", defaultMessage: "{name} copy" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Loading toast title while duplication is in progress */
            duplicating: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDuplicateCollection.duplicating?c=3jt2zfic1tgch", defaultMessage: "Duplicating collection" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown after a successful duplication */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDuplicateCollection.success?c=3h0m6tk4kwd36", defaultMessage: "Collection duplicated" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when duplication fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDuplicateCollection.error?c=7cgbd4b9eqjb", defaultMessage: "Collection could not be duplicated" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
